import React, { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { InspoJourney } from '../../../services';

type InspoCta = {
    /** True on the public stories page and the wallmates.com embed, where nobody is signed in yet. */
    publicMode: boolean;
    /** Public: open sign-up (the host page decides how). */
    getStarted: (journey: InspoJourney) => void;
};

const InspoCtaContext = createContext<InspoCta>({ publicMode: false, getStarted: () => undefined });

// #region InspoCtaProvider
export const InspoCtaProvider: React.FunctionComponent<React.PropsWithChildren<InspoCta>> = ({ children, ...value }) => (
    <InspoCtaContext.Provider value={value}>{children}</InspoCtaContext.Provider>
);

// #region useInspoCta
/**
 * Where a call to action goes: inside the dashboard, the page it names; in public, sign-up.
 * `go(href, journey)` does the right one.
 */
export const useInspoCta = () => {
    const ctx = useContext(InspoCtaContext);
    const navigate = useNavigate();
    const go = (href: string, journey: InspoJourney) => (ctx.publicMode ? ctx.getStarted(journey) : navigate(href));
    return { ...ctx, go };
};
